import {
  TermeneMappedData,
  TermeneReferentials,
  TermeneResponseDto
} from '../interfaces/Organization';
import { normalizePostalCode, removeDiacritics } from '../utils/general';

export function mapTermeneResponse(
  data: TermeneResponseDto,
  ref: TermeneReferentials
): TermeneMappedData {
  const companyName = data?.firma?.nume_mfinante || '';
  const address = data?.adresa?.sediu_social?.formatat || '';
  const phone = data?.date_contact?.telefon?.length
    ? data?.date_contact?.telefon[0]
    : '';
  const tara = data?.adresa?.sediu_social?.tara || '';
  const judet = data?.adresa?.sediu_social?.judet || '';
  const registryNumber = data?.firma?.j || '';
  const localitate = data?.adresa?.sediu_social?.localitate || '';
  const sector = (data?.adresa?.anaf?.sector || '') as any;
  const rawPostal = String(
    data?.adresa?.sediu_social?.cod_postal ??
      data?.adresa?.anaf?.cod_postal ??
      ''
  );
  const postalCode = normalizePostalCode(rawPostal);
  const companyNumber =
    data?.firma?.cui !== undefined && data?.firma?.cui !== null
      ? String(data.firma.cui)
      : '';

  const normalizedCounty = removeDiacritics(judet);
  const normalizedCity = removeDiacritics(localitate);
  const isBucharest = normalizedCounty.trim().toLowerCase() === 'bucuresti';
  let cityForLookup = normalizedCity;
  if (isBucharest && sector) {
    const sect = String(sector).trim();
    cityForLookup = `Bucuresti Sectorul ${sect}`;
  }

  const country =
    ref.countries.length > 0
      ? ref.countries.find((c) => c.displayName === tara) ?? null
      : null;

  const region = country
    ? ref.regions.find(
        (r) => r.displayName === normalizedCounty && r.dependencyId === country.id
      ) ?? null
    : null;

  const city =
    region
      ? ref.cities.find(
          (c) => c.displayName === cityForLookup && c.dependencyId === region.id
        ) ?? null
      : null;

  return {
    companyNumber,
    companyName,
    registryNumber,
    address,
    phone,
    postalCode,
    country,
    countryId: country?.id ?? null,
    region,
    regionId: region?.id ?? null,
    city,
    cityId: city?.id ?? null
  };
}
